module.exports = __webpack_public_path__ + "img/empty.fe08ba8a.png";